import React from 'react';
import s from './List.module.css';
import classNames from 'classnames/bind';
import { useState, useEffect } from 'react';
// import Ribbon from '../../../Ribbon/Ribbon';
import shortid from 'shortid';

function List({ data, type, svg }) {
  const [isOpened, setIsOpened] = useState(true);
  let cx = classNames.bind(s);
  let classNameForList = cx({
    render: true,
    closed: !isOpened,
  });
  let classNameForListMainHeader = cx({
    listMainHeader: true,
    listMainHeader__closed: !isOpened,
  });
  let classNameForSvg = cx({
    svg: true,
    svg__closed: !isOpened,
  });

  const onClick = () => {
    setIsOpened(!isOpened);
  };

  useEffect(() => {
    if (type === 'Драйвера та інструкції') {
      setIsOpened(false);
    }
  }, [type]);

  return (
    <ul className={s.listMain}>
      <li className={classNameForListMainHeader} onClick={onClick} key={type}>
        {type}
        <svg className={classNameForSvg}>
          <use href={svg}></use>
        </svg>
      </li>

      <li className={classNameForList} key={shortid.generate()}>
        {isOpened && data.length > 0 && (
          <ul>
            {data.map(({ name, value }) => {
              return (
                <li className={s.listMainItem} key={name}>
                  {name}
                  <ul>
                    {value &&
                      value.map(el => {
                        return (
                          <li className={s.listInnerItem} key={el}>
                            {el}
                          </li>
                        );
                      })}
                  </ul>
                </li>
              );
            })}
          </ul>
        )}
      </li>
    </ul>
  );
}

export default List;
